"use strict";
import React from 'react';
import { Link } from "react-router-dom";
import FormsyFields from './formsyFields';
import Formsy from './formsy';
import loaders from './loaders';
import {
    getPasswordValidation,
    notEqualsIgnoreCase
} from '../util/validationUtils';

const initComponent = ({ flex, FlexApiRequest } = window) => {
    class Register extends React.PureComponent {
        state = {
            registrationData: null,
            model: { },
            canSubmit: false,
            dataReady: false
        };

        componentDidMount() {
            this.fetchRegistrationData();

            const formHandler = this.context.formHandler || {};
            formHandler.onSubmit = this.onSubmit;
            this.unmounting = false;
        }

        enableButton = () => {
            this.setState({ canSubmit: true });
        };

        disableButton = () => {
            this.setState({ canSubmit: false });
        };

        fetchRegistrationData = () => {
            FlexApiRequest.POST({ path: '/api/v1/auth/getregistrationdata' })
                .send({ })
                .then(({ data }) => {
                    flex.setBusy("app:getRegistrationData", false);
                    if (!this.unmounting) {
                        const store = flex.getStore();
                        store.set({ registrationData: data, dataReady: true });

                        this.setState({
                            registrationData: data,
                            dataReady: true
                        });
                    }
                })
                .catch(({ handledErrors }) => {
                    if (handledErrors && handledErrors.length > 0) {
                        handledErrors.forEach(error => {
                            flex.addPageAlerts({
                                summary: error.summary,
                                selfCloseTimeout: 10000
                            });
                        });
                    }

                    this.setState({ dataReady: true });
                });
        };

        handleSubmit = (model) => {
            let activeSpinner = flex.showSpinner(document.querySelector('.ladda-button'));
            this.setState({
                dataReady: false,
                model: model,
                canSubmit: false
            });

            FlexApiRequest.POST({ path: '/api/v1/auth/registeruser'})
                .send(model)
                .then(() => {
                    flex.hideSpinner(activeSpinner);
                    flex.redirect("/");
                })
                .catch(({ handledErrors }) => {
                    if (handledErrors && handledErrors.length > 0) {
                        handledErrors.forEach(error => {
                            flex.addPageAlerts({
                                summary: error.summary,
                                selfCloseTimeout: 10000
                            });
                        });
                    }

                    this.setState({ dataReady: true });
                });
        };

        render() {
            const {
                registrationData,
                model,
                dataReady
            } = this.state;

            if (!registrationData || !dataReady) {
                return loaders.loader;
            }

            const firstNameLabel = flex.text("UX_LOGIN_LBL_FIRSTNAME");
            const lastNameLabel = flex.text("UX_LOGIN_LBL_LASTNAME");
            const usernameLabel = flex.text("UX_LOGIN_LBL_USERNAME");
            const passwordLabel = flex.text("UX_LOGIN_LBL_PASSWORD");
            const emailLabel = flex.text("UX_LOGIN_LBL_EMAIL");

            // security questions
            var question1 = [{ label: "--Select--", value: "-1" }];
            var question2 = [{ label: "--Select--", value: "-1" }];

            const questions = registrationData.questions;
            const count = questions.length;
            const half = count / 2;
            const questions1 = questions.slice(0, half);
            const questions2 = questions.slice(half, count);

            question1 = question1.concat(questions1.map((questions1) => { return { label: questions1, value: questions1 } }));
            question2 = question2.concat(questions2.map((questions2) => { return { label: questions2, value: questions2 } }));

            const formProps = { layout: "vertical" };
            const passwordValidation = getPasswordValidation();

            return (
                <section className="container page-sub">
                    <header className="content-header">
                        <h1>{flex.text("UX_LOGIN_HDR_REGISTER", "Register")}</h1>
                    </header>
                    <Formsy.Form
                        style={{ textAlign: "left" }}
                        model={model}
                        onValidSubmit={this.handleSubmit}
                        onValid={this.enableButton}
                        onInvalid={this.disableButton}
                    >
                        <FormsyFields.Input
                            style={{ display: "None" }}
                            id="formMessage"
                            name="formMessage"
                            value=""
                            type="text"
                        />
                        <fieldset>
                            <div className="row">
                                <div className="col-sm-6">
                                    <FormsyFields.Input
                                        {...formProps}
                                        id="firstName"
                                        name="firstName"
                                        label={firstNameLabel}
                                        placeholder={firstNameLabel}
                                        type="text"
                                        value={model.firstName}
                                        validationError="First Name is a required field"
                                        required
                                    />
                                </div>
                                <div className="col-sm-6">
                                    <FormsyFields.Input
                                        {...formProps}
                                        id="lastName"
                                        name="lastName"
                                        label={lastNameLabel}
                                        placeholder={lastNameLabel}
                                        value={model.lastName}
                                        type="text"
                                        validationError="Last Name is a required field"
                                        required
                                    />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-sm-6">
                                    <FormsyFields.Input
                                        {...formProps}
                                        id="username"
                                        name="username"
                                        label={usernameLabel}
                                        placeholder={usernameLabel}
                                        value={model.username}
                                        type="text"
                                        validationError="Last Name is a required field"
                                        required
                                    />
                                </div>
                                <div className="col-sm-6">
                                    <FormsyFields.Input
                                        {...formProps}
                                        id="email"
                                        name="email"
                                        label={emailLabel}
                                        placeholder={emailLabel}
                                        value={model.email}
                                        type="email"
                                        validations="isEmail"
                                        validationError="Please enter a valid email address"
                                        required
                                    />
                                </div>
                            </div>

                            <h2>Password</h2>
                            <div className="row">
                                <div className="col-sm-6">
                                    <FormsyFields.Input
                                        {...formProps}
                                        id="password"
                                        name="password"
                                        label={passwordLabel}
                                        placeholder={passwordLabel}
                                        value={model.password}
                                        type="password"
                                        required
                                        validations={{
                                            ...passwordValidation.validators,
                                            notEqualsToUserName: model => notEqualsIgnoreCase(model['password'], model['username'])
                                        }}
                                        validationError="Password is a required field"
                                        validationErrors={{
                                            ...passwordValidation.errorMessages,
                                            notEqualsToUserName: 'Password cannot be the same as Username'
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-6">
                                    <FormsyFields.Input
                                        {...formProps}
                                        id="password2"
                                        name="password2"
                                        label="Confirm Password"
                                        placeholder="Type confirmation password"
                                        value={model.password}
                                        type="password"
                                        validations="equalsField:password"
                                        validationError="Passwords must match"
                                        required
                                    />
                                </div>
                            </div>
                            <h2>Security Questions</h2>
                            <div className="row">
                                <div className="col-sm-6">
                                    <div className="form-group select">
                                        <FormsyFields.Select
                                            {...formProps}
                                            id="SecurityQuestion1"
                                            name="SecurityQuestion1"
                                            label="Security Question 1"
                                            value={model.SecurityQuestion1}
                                            options={question1}
                                            validations={{
                                                myCustomValidation: function (values, value) {
                                                    values; // Other current values in form
                                                    value;
                                                    if (value == -1) { return false; }
                                                    return true;
                                                }
                                            }}
                                            validationError="Please select a security question."
                                            required
                                        />
                                    </div>
                                    <div className="form-group text">
                                        <FormsyFields.Input
                                            {...formProps}
                                            id="answer1"
                                            name="answer1"
                                            label="Answer 1"
                                            placeholder="Type your answer"
                                            value={model.answer1}
                                            type="text"
                                            required
                                        />
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="form-group select">
                                        <FormsyFields.Select
                                            {...formProps}
                                            id="SecurityQuestion2"
                                            name="SecurityQuestion2"
                                            label="Security Question 2"
                                            value={model.SecurityQuestion2}
                                            options={question2}
                                            validations={{
                                                myCustomValidation: function (values, value) {
                                                    values; // Other current values in form
                                                    value;
                                                    if (value == -1) { return false; }
                                                    return true;
                                                }
                                            }}
                                            validationError="Please select a 2nd security question."
                                            required
                                        />
                                    </div>
                                    <div className="form-group text">
                                        <FormsyFields.Input
                                            {...formProps}
                                            id="answer2"
                                            name="answer2"
                                            label="Answer 2"
                                            placeholder="Type your answer"
                                            value={model.answer2}
                                            type="text"
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="row">
                                    <div className="col-xs-6 col-sm-5 col-sm-offset-4 col-md-4 col-md-offset-4">
                                        <Link className="btn btn-cancel" to="/">{flex.text("UX_ACT_CANCEL")}</Link>
                                    </div>
                                    <div className="col-xs-6 col-sm-3 col-md-4">
                                        <button className="btn ladda-button" type="submit" disabled={!this.state.canSubmit}>{flex.text("UX_LOGIN_ACT_REGISTER")}</button>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    </Formsy.Form>
                    <br />
                </section>
            );
        }
    }

    return Register;

};

module.exports = initComponent;
